var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.memberLocked && _vm.memberDetails.member.generateIdCard)?_c('async-button',{staticClass:"_mls _mt0 white --sm",attrs:{"type":"button","disabled":_vm.submitEnabled ? null : 'disabled',"executing":_vm.isSubmitting},on:{"clicked":function($event){return _vm.handleFileDownload({
        reportId: _vm.memberDetails.member.memberCk,
        type: 'CARD',
        fileName: 'IdCard.pdf',
        dateOfService: _vm.memberDetails.member.benefitServiceDate,
        groupCk: _vm.memberDetails.member.groupCk,
        subGroupCk: _vm.memberDetails.member.subgroupCk || _vm.memberDetails.member.subGroupCk
      })}},scopedSlots:_vm._u([{key:"buttonContent",fn:function(){return [_c('span',[_vm._v("PRINT ID CARD")])]},proxy:true}],null,false,2059213489)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }